import { AxiosResponse } from 'axios';
import { useAlert, useAuth } from 'core/contexts';
import {
    withHeaders,
    instance as axiosInstance,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { commonShowAlert } from 'lib';
import { useQuery, UseQueryResult } from 'react-query';
import { Metrics } from '../pages/dashboard/dashboard-helper';

const fetchDashboardMetrics = async (
    url: string,
    token: string
): Promise<AxiosResponse<Metrics, any>> => {
    const headers = getDefaultHeaders(token);
    return axiosInstance().get(url, withHeaders(headers));
};

export const useDashboardMetrics = (): UseQueryResult<
    AxiosResponse<Metrics, any>,
    unknown
> => {
    const { getToken } = useAuth();
    const { showAlert, hideAlert, showErrorDetails } = useAlert();
    const url = '/metrics/sdz';

    return useQuery(
        'dashboard-metrics',
        async () => fetchDashboardMetrics(url, getToken()),
        {
            onError: (error: any) => {
                const errorMessage: string =
                    error?.data?.message ??
                    'Unable to retrieve dashboard metrics';
                commonShowAlert(
                    showAlert,
                    hideAlert,
                    'error',
                    errorMessage,
                    JSON.stringify(error?.data ?? ''),
                    showErrorDetails
                );
            },
        }
    );
};
